var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclright(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4654 6.44145L20.4917 11.0754L15.8577 19.1018L14.1662 18.1252L17.1331 12.9864L6.39308 15.8642L5.88758 13.9776L16.6276 11.0998L11.4888 8.13295L12.4654 6.44145ZM25.3834 9.76473C26.2475 12.9898 25.8041 16.3585 24.1346 19.25C22.4652 22.1415 19.7696 24.2099 16.5445 25.074C13.3195 25.9382 9.95082 25.4947 7.0593 23.8253C4.16778 22.1559 2.09939 19.4603 1.23524 16.2352C0.371089 13.0102 0.814562 9.64148 2.48398 6.74996C4.1534 3.85844 6.84903 1.79004 10.0741 0.925895C13.2991 0.0617462 16.6678 0.505219 19.5593 2.17464C22.4508 3.84406 24.5192 6.53968 25.3834 9.76473ZM23.4968 10.2702C21.9916 4.65289 16.1969 1.3073 10.5796 2.81247C4.96223 4.31763 1.61665 10.1124 3.12181 15.7297C4.62698 21.347 10.4217 24.6926 16.039 23.1875C21.6564 21.6823 25.002 15.8876 23.4968 10.2702Z",
    fill: "#8A3FFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclright);
export default __webpack_public_path__ + "static/media/circlright.fe09df38bb9b01802f6ef47cd6a2d123.svg";
export { ForwardRef as ReactComponent };